module.exports = __webpack_public_path__ + "static/media/Ultrasonido.8a760270.svg";